// @ts-ignore
if (window.__ASSET_URL__) {
	// @ts-ignore
	__webpack_public_path__ = window.__ASSET_URL__;
}

import('./bootstrap');
